import {
  FETCH_NOTIFICATIONS_BEGIN,
  FETCH_NOTIFICATIONS_FULFILLED,
  FETCH_NOTIFICATIONS_REJECTED,
  POST_NOTIFICATION_READ_STATUS_BEGIN,
  POST_NOTIFICATION_READ_STATUS_FULFILLED,
  POST_NOTIFICATION_READ_ALL_STATUS_FULFILLED,
  POST_NOTIFICATION_READ_STATUS_REJECTED,
  DELETE_NOTIFICATION_BEGIN,
  DELETE_NOTIFICATION_FULFILLED,
  DELETE_NOTIFICATION_REJECTED,
} from "../actions/notificationActions";

export function notificationsReducer(
  state = {
    loading: false,
    notifications: [],
    error: null,
  },
  action
) {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_NOTIFICATIONS_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_NOTIFICATIONS_FULFILLED: {
      return {
        ...state,
        loading: false,
        notifications: action.payload,
      };
    }
    case POST_NOTIFICATION_READ_STATUS_BEGIN: {
      return { ...state, loading: true };
    }
    case POST_NOTIFICATION_READ_STATUS_FULFILLED: {
      let tempNotifications = [...state.notifications];
      tempNotifications.forEach((noti) => {
        if (noti.notice.id === action.payload.id) {
          noti.isSeenByMe = action.payload.read;
        }
      });
      return {
        ...state,
        loading: false,
        notifications: tempNotifications,
      };
    }
    case POST_NOTIFICATION_READ_ALL_STATUS_FULFILLED: {
      return {
        ...state,
        loading: false,
        notifications: action.payload,
      };
    }
    case POST_NOTIFICATION_READ_STATUS_REJECTED: {
      return { ...state };
    }
    case DELETE_NOTIFICATION_BEGIN: {
      return { ...state, loading: true };
    }
    case DELETE_NOTIFICATION_FULFILLED: {
      let tempNotificationsForDelete = [...state.notifications];
      tempNotificationsForDelete.forEach((noti) => {
        if (noti.notice.id === action.payload.id) {
          noti.notice.isDeleted = action.payload.isDeleted;
        }
      });
      return {
        ...state,
        notifications: tempNotificationsForDelete,
        loading: false,
      };
    }
    case DELETE_NOTIFICATION_REJECTED: {
      return { ...state, loading: false };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
